export default "__VITE_ASSET__C0tAsJ7r__"